const login = {
  'username': 'required',
  'password': 'required'
};

const forgotPassword = {
  'username': 'required'
};

export const resetPasswordRules = {
  'password': 'required',
  'confirmation': 'required',
};

const profile = {
  'firstName': 'required',
  'lastName': 'required'
};

const changePassword = {
  'oldPassword': 'required',
  'newPassword': 'required',
  'confirmNewPassword': 'required|same:newPassword'
};

const registration = {
  'firstName': 'required',
  'lastName': 'required',
  'email': 'required',
  'companyName': 'required',
  'companyAddress1': 'required',
  'city': 'required',
  'state': 'required',
  'zip': 'required',
  'phoneNumber': 'required',
  'BrokerIsCorrespondent': 'required',
  'companySelection': 'required',
};

export {
  login,
  forgotPassword,
  profile,
  changePassword,
  registration
};
